import * as React from "react";
import { joinCn } from "@ati/uti";
import styles from "../Popup.module.scss";
var ActionWrapper = _ref => {
  var {
    className = "",
    children,
    type
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: joinCn(styles["popup-action-wrapper-button"], type && styles["action-".concat(type)], className)
  }, children);
};
export default ActionWrapper;